<template>
    <div class="user-select">
        <div v-for="user in users" :key="user[valuePath]" :class="userClass(user[valuePath])" @click="selectUser(user)">
            <div>
                <div v-if="!isCurrentUserSelected(user) && showArrows" class="user-select__reply-solid">
                    <common-icon name="reply-solid" size="small" class="user-select__reply-solid__icon"></common-icon>
                </div>
                <common-user-avatar class="user-select__user--avatar" :user="user" size="small"></common-user-avatar>
                <div class="user-select__user--name">{{ user.firstName }} {{ user.lastName }}</div>
                <div class="user-select__user--availability">
                    {{ getTranslation(user.availabilityTitle) }}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TranslateMixin from 'mixins/TranslateMixin'

    export default {
        mixins: [TranslateMixin],

        props: {
            users: { type: Array, required: true },
            valuePath: { type: String, default: 'id' },
            showArrows: { type: Boolean, default: false },
        },

        data: () => ({ selectedUser: {} }),

        methods: {
            selectUser(user) {
                if (this.selectedUser[this.valuePath] === user[this.valuePath]) {
                    return
                }
                this.selectedUser = user
                this.emitEvent({ name: 'user-selected', payload: { ...user } })
            },

            userClass(value) {
                return {
                    'user-select__user': true,
                    'user-select__user--selected': value === this.selectedUser[this.valuePath],
                }
            },

            isCurrentUserSelected(user) {
                return this.selectedUser.availabilityOfferId === user.availabilityOfferId
            },
        },

        watch: {
            users() {
                if (this.users.length) {
                    this.selectUser(this.users[0])
                }
            },

            '$route.query'() {
                if (this.$route.query.selectedUserId) {
                    const user = this.users.find((user) => user.availabilityOfferId === Number(this.$route.query.selectedUserId))
                    this.selectUser(user)
                }
            },
        },

        mounted() {
            if (this.$route.query.selectedUserId) {
                const user = this.users.find((user) => user.availabilityOfferId === Number(this.$route.query.selectedUserId))
                this.selectUser(user)
                return
            }
            if (this.users.length) {
                this.selectUser(this.users[0])
            }
        },
    }
</script>

<style scoped lang="scss">
    @import 'styles/components/user/_user-select.scss';
</style>
